import { render } from "./NotificationsOffcanvas.vue?vue&type=template&id=43534c22&scoped=true"
import script from "./NotificationsOffcanvas.vue?vue&type=script&lang=js"
export * from "./NotificationsOffcanvas.vue?vue&type=script&lang=js"

import "./NotificationsOffcanvas.vue?vue&type=style&index=0&id=43534c22&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43534c22"]])

export default __exports__